"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alerts = void 0;

var alert_1 = require("./alert");

var alerts_1 = __importDefault(require("./http/alerts")); // NOTE: This follows the pattern of Units and UsagePoints so if you feel like changing this interface, please consider consistency between those.


var Alerts;

(function (Alerts) {
  function find(id, alerts) {
    var e_1, _a;

    try {
      for (var alerts_2 = __values(alerts), alerts_2_1 = alerts_2.next(); !alerts_2_1.done; alerts_2_1 = alerts_2.next()) {
        var alert_2 = alerts_2_1.value;

        if (alert_2.id === id) {
          return alert_2;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (alerts_2_1 && !alerts_2_1.done && (_a = alerts_2.return)) _a.call(alerts_2);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  Alerts.find = find;
  /**
   * Remove removes a given ID from the set of alerts if present and returns it
   * @param id the id of the alert to remove
   * @param alerts the set of alerts to remove it from
   */

  function remove(id, alerts) {
    for (var i = 0; i < alerts.length; i++) {
      if (alerts[i].id === id) {
        alerts.splice(i, 1);
        return alerts;
      }
    }

    return alerts;
  }

  Alerts.remove = remove;
  /**
   * Filter takes an expression and performs filtering of either UUID or alert based on it
   * @param filterExpr
   * @param severity
   * @param alerts
   */

  function filter(filterExpr, severity, alerts, units) {
    var e_2, _a, e_3, _b;

    if (filterExpr === void 0) {
      filterExpr = "";
    }

    if (severity === void 0) {
      severity = alert_1.AlertSeverity.NotApplicable;
    }

    var ret = [];

    try {
      for (var alerts_3 = __values(alerts), alerts_3_1 = alerts_3.next(); !alerts_3_1.done; alerts_3_1 = alerts_3.next()) {
        var alert_3 = alerts_3_1.value;
        var severityMatches = true;

        if (severity != alert_1.AlertSeverity.NotApplicable) {
          severityMatches = alert_3.severity === severity;
        }

        var unitMatches = true;

        if (units != null && severityMatches) {
          // lets not go looping if we don't need to
          var foundInUnits = false;

          try {
            for (var units_1 = (e_3 = void 0, __values(units)), units_1_1 = units_1.next(); !units_1_1.done; units_1_1 = units_1.next()) {
              var unit = units_1_1.value;

              if (alert_3.uuid.equals(unit.uuid)) {
                foundInUnits = true;
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (units_1_1 && !units_1_1.done && (_b = units_1.return)) _b.call(units_1);
            } finally {
              if (e_3) throw e_3.error;
            }
          }

          unitMatches = foundInUnits;
        }

        var expressionMatches = true;

        if (filterExpr.length > 0) {
          expressionMatches = alert_3.uuid.contains(filterExpr) || alert_3.message.includes(filterExpr);
        }

        if (severityMatches && (unitMatches || expressionMatches)) {
          ret.push(alert_3);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (alerts_3_1 && !alerts_3_1.done && (_a = alerts_3.return)) _a.call(alerts_3);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return ret;
  }

  Alerts.filter = filter;
  /**
   * Merge merges two sets of alerts into one, where the first parameter is the newer data and the second one contains the source
   * @param newAlerts - The changes to be merge into the source
   * @param source  - The source array used
   */

  function mergeInPlace(newAlerts, source) {
    for (var i = 0; i < newAlerts.length; i++) {
      var replaced = false;

      for (var j = 0; j < source.length; j++) {
        if (newAlerts[i].id === source[j].id) {
          source[j] = newAlerts[i];
          replaced = true;
        }
      }

      if (!replaced) {
        source.push(newAlerts[i]);
      }
    }

    return source;
  }

  Alerts.mergeInPlace = mergeInPlace;
  /**
   * Merge merges two sets of alerts into one, where the first parameter is the newer data and the second one contains the source
   * @param newAlerts - The changes to be merge into the source
   * @param source  - The source array used
   */

  function merge(newAlerts, source) {
    var ret = source.slice(0);

    for (var i = 0; i < newAlerts.length; i++) {
      var replaced = false;

      for (var j = 0; j < ret.length; j++) {
        if (newAlerts[i].id === ret[j].id) {
          ret[j] = newAlerts[i];
          replaced = true;
          break;
        }
      }

      if (!replaced) {
        ret.push(newAlerts[i]);
      }
    }

    return ret;
  }

  Alerts.merge = merge;

  function get(credentials, time) {
    return alerts_1.default(time, credentials).then(function (resp) {
      var e_4, _a;

      var ret = [];

      try {
        for (var resp_1 = __values(resp), resp_1_1 = resp_1.next(); !resp_1_1.done; resp_1_1 = resp_1.next()) {
          var d = resp_1_1.value;
          ret.push(alert_1.decodeAlert(d));
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (resp_1_1 && !resp_1_1.done && (_a = resp_1.return)) _a.call(resp_1);
        } finally {
          if (e_4) throw e_4.error;
        }
      }

      return ret;
    });
  }

  Alerts.get = get;
})(Alerts = exports.Alerts || (exports.Alerts = {}));